<template>
  <div class="main print-no-padding">
    <h2 class="is-print-hide title-area">
      <span class="main-title">查看职员</span>
    </h2>
    <breadcrumb firstName="职员管理"></breadcrumb>
    <shop-content :type="2"></shop-content>
  </div>
</template>
<script>
import breadcrumb from '@/components/global/breadcrumb';
import shopContent from './components/content.vue';
export default {
  components: {
    breadcrumb,
    shopContent
  }
};
</script>
